// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./base.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./Input.module.css";
import ___CSS_LOADER_ICSS_IMPORT_2___ from "-!../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./Group.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_2___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qAkVquXTPIw5OOjz {
  --lp-button-inline-start: var(--lp-button-inline-text);
  --lp-button-inline-end: var(--lp-button-inline-text);
}

.qAkVquXTPIw5OOjz[data-pending] {
  --lp-button-inline-start: var(--lp-button-inline-icon);
}

.qAkVquXTPIw5OOjz:has( > [slot="start-icon"]) {
  --lp-button-inline-start: var(--lp-button-inline-icon);
}

.qAkVquXTPIw5OOjz:has( > [slot="end-icon"]) {
  --lp-button-inline-end: var(--lp-button-inline-icon);
}

.qAkVquXTPIw5OOjz > .pLbjuipDnIQq4CjT, .qAkVquXTPIw5OOjz > [slot="start-icon"] {
  order: -1;
}

.qAkVquXTPIw5OOjz > [slot="end-icon"] {
  order: 1;
}

.R0s2xO5mjiMQTGsJ {
  appearance: none;
  border-radius: var(--lp-border-radius-medium);
  align-items: center;
  gap: var(--lp-button-gap, var(--lp-spacing-200));
  white-space: nowrap;
  border: none;
  outline: none;
  justify-content: center;
  margin: 0;
  text-decoration: none;
  display: inline-flex;
  position: relative;
}

.R0s2xO5mjiMQTGsJ[data-focus-visible] {
  outline: 2px solid var(--lp-color-shadow-interactive-focus);
  outline-offset: -2px;
  z-index: 2;
}

.R0s2xO5mjiMQTGsJ[data-disabled] {
  opacity: .64;
}

[data-spacing=compact][data-orientation=horizontal] > :is(.sNaMUneaUQtLIw9K, .AfUPnEG_w4EK4Drs):not(:first-child) {
  border-inline-start: 1px solid var(--lp-button-divider-color);
}

[data-spacing=compact][data-orientation=vertical] > :is(.sNaMUneaUQtLIw9K, .AfUPnEG_w4EK4Drs):not(:first-child) {
  border-block-start: 1px solid var(--lp-button-divider-color);
}

.oFLacyeZZ4QtTWGw {
  font: var(--lp-text-label-2-semibold);
  padding-block: calc(3px + var(--lp-button-padding, 0px));
}

.SdypMiIBMQ0dORgh, .oFLacyeZZ4QtTWGw {
  --lp-button-inline-text: var(--lp-spacing-300);
  --lp-button-inline-icon: var(--lp-spacing-300);
  --lp-button-gap: var(--lp-spacing-200);
  padding-inline: var(--lp-button-inline-start) var(--lp-button-inline-end);
}

.SdypMiIBMQ0dORgh {
  font: var(--lp-text-label-1-semibold);
  padding-block: calc(5px + var(--lp-button-padding, 0px));
}

.AqwHsmWS4oERbxe0 {
  --lp-button-inline-text: var(--lp-spacing-400);
  --lp-button-inline-icon: var(--lp-spacing-400);
  --lp-button-gap: var(--lp-spacing-200);
  font: var(--lp-text-body-1-semibold);
  padding-block: calc(7px + var(--lp-button-padding, 0px));
  padding-inline: var(--lp-button-inline-start) var(--lp-button-inline-end);
}

[data-lp-hit-area=expanded] .R0s2xO5mjiMQTGsJ.oFLacyeZZ4QtTWGw:before {
  content: "";
  inset-block: min(0px,calc((100% - var(--lp-size-32))/2));
  inset-inline: min(0px,calc((100% - var(--lp-size-32))/2));
  position: absolute;
}

[data-lp-hit-area=expanded]
			:is([data-spacing=compact],[data-appearance=default])[data-orientation=horizontal] > .R0s2xO5mjiMQTGsJ.oFLacyeZZ4QtTWGw:before {
  inset-inline: 0;
}

[data-lp-hit-area=expanded]
			:is([data-spacing=compact],[data-appearance=default])[data-orientation=vertical] > .R0s2xO5mjiMQTGsJ.oFLacyeZZ4QtTWGw:before {
  inset-block: 0;
}

.AVtbvvllnowOwdkm {
  --lp-button-padding: 0px;
  background-color: var(--lp-color-bg-interactive-secondary-base);
  border: 1px solid var(--lp-color-border-interactive-secondary-base);
  color: var(--lp-color-text-ui-primary-base);
}

.AVtbvvllnowOwdkm[data-hovered]:where(:not([aria-disabled="true"])) {
  background-color: var(--lp-color-bg-interactive-secondary-hover);
}

.AVtbvvllnowOwdkm[data-pressed]:where(:not([aria-disabled="true"])) {
  background-color: var(--lp-color-bg-interactive-secondary-active);
}

.AVtbvvllnowOwdkm[data-focus-visible] {
  background-color: var(--lp-color-bg-interactive-secondary-focus);
}

.sNaMUneaUQtLIw9K {
  --lp-button-padding: 1px;
  --lp-button-divider-color: color-mix(in oklab,var(--lp-color-shadow-interactive-primary) 40%,var(--lp-color-bg-interactive-primary-base));
  background-color: var(--lp-color-bg-interactive-primary-base);
  color: var(--lp-color-text-interactive-primary-base);
  z-index: 1;
}

.sNaMUneaUQtLIw9K [data-icon] {
  fill: var(--lp-color-text-interactive-primary-base);
}

.sNaMUneaUQtLIw9K[data-hovered]:where(:not([aria-disabled="true"])) {
  background-color: var(--lp-color-bg-interactive-primary-hover);
  color: var(--lp-color-text-interactive-primary-hover);
}

.sNaMUneaUQtLIw9K[data-pressed]:where(:not([aria-disabled="true"])) {
  background-color: var(--lp-color-bg-interactive-primary-active);
  color: var(--lp-color-text-interactive-primary-active);
}

.sNaMUneaUQtLIw9K[data-focus-visible] {
  background-color: var(--lp-color-bg-interactive-primary-focus);
  box-shadow: inset 0 0 0 3px var(--lp-color-shadow-interactive-primary);
  color: var(--lp-color-text-interactive-primary-focus);
}

.AfUPnEG_w4EK4Drs {
  --lp-button-padding: 1px;
  --lp-button-divider-color: color-mix(in oklab,var(--lp-color-shadow-interactive-primary) 40%,var(--lp-color-bg-interactive-destructive-base));
  background-color: var(--lp-color-bg-interactive-destructive-base);
  color: var(--lp-color-text-interactive-primary-base);
}

.AfUPnEG_w4EK4Drs [data-icon] {
  fill: var(--lp-color-text-interactive-primary-base);
}

.AfUPnEG_w4EK4Drs[data-hovered]:where(:not([aria-disabled="true"])) {
  background-color: var(--lp-color-bg-interactive-destructive-hover);
}

.AfUPnEG_w4EK4Drs[data-pressed]:where(:not([aria-disabled="true"])) {
  background-color: var(--lp-color-bg-interactive-destructive-active);
}

.AfUPnEG_w4EK4Drs[data-focus-visible] {
  background-color: var(--lp-color-bg-interactive-destructive-focus);
  box-shadow: inset 0 0 0 3px var(--lp-color-shadow-interactive-primary);
}

.FbfCfkse98KF6seC {
  --lp-button-padding: 1px;
  background-color: var(--lp-color-bg-interactive-tertiary-base);
  color: var(--lp-color-text-ui-primary-base);
}

.FbfCfkse98KF6seC[data-hovered]:where(:not([aria-disabled="true"])) {
  background-color: var(--lp-color-bg-interactive-tertiary-hover);
}

.FbfCfkse98KF6seC[data-pressed]:where(:not([aria-disabled="true"])) {
  background-color: var(--lp-color-bg-interactive-tertiary-active);
}

.FbfCfkse98KF6seC[data-focus-visible] {
  background-color: var(--lp-color-bg-interactive-tertiary-focus);
}

.R0s2xO5mjiMQTGsJ[data-selected]:where(button, label) {
  background-color: var(--lp-color-bg-interactive-selected);
  border-color: var(--lp-color-border-interactive-selected);
  z-index: 1;
}

.R0s2xO5mjiMQTGsJ[data-pending] {
  cursor: wait;
}

.R0s2xO5mjiMQTGsJ[data-pending] [data-icon], .AAHxZOiXG2E9j8sy {
  opacity: .5;
}

.pLbjuipDnIQq4CjT {
  --fill-color: currentColor;
}

.W3_PUi1brqEJgtXt {
  --lp-button-inline-text: var(--lp-spacing-300);
  --lp-button-inline-icon: var(--lp-spacing-300);
  --lp-button-gap: var(--lp-spacing-300);
  gap: var(--lp-button-gap);
  padding-inline: var(--lp-button-inline-start) var(--lp-button-inline-end);
}

.W3_PUi1brqEJgtXt [data-icon]:last-child {
  fill: var(--lp-color-fill-ui-secondary);
}

:where(html[data-launchpad-button-spacing]) .oFLacyeZZ4QtTWGw {
  --lp-button-inline-icon: var(--lp-size-4);
  --lp-button-gap: var(--lp-size-2);
  --lp-button-inline-text: var(--lp-size-6);
  font: var(--lp-text-label-1-medium);
  padding-block: calc(var(--lp-size-1) + var(--lp-button-padding, 0px));
}

:where(html[data-launchpad-button-spacing]) .oFLacyeZZ4QtTWGw .iD4tuvolrkYC_GAd {
  font: inherit;
}

:where(html[data-launchpad-button-spacing]) .oFLacyeZZ4QtTWGw > svg {
  height: var(--lp-size-14);
  width: var(--lp-size-14);
}

:where(html[data-launchpad-button-spacing]) .SdypMiIBMQ0dORgh {
  --lp-button-inline-icon: var(--lp-size-6);
  --lp-button-gap: var(--lp-size-3);
  --lp-button-inline-text: calc(var(--lp-size-6) + var(--lp-size-3));
}

:where(html[data-launchpad-button-spacing]) .qAkVquXTPIw5OOjz.W3_PUi1brqEJgtXt {
  --lp-button-inline-icon: var(--lp-size-6);
  --lp-button-gap: var(--lp-size-3);
  --lp-button-inline-text: calc(var(--lp-size-6) + var(--lp-size-3));
  gap: var(--lp-button-gap);
  padding-inline: var(--lp-button-inline-start) var(--lp-button-inline-end);
}

:where(html[data-launchpad-button-spacing]) .AqwHsmWS4oERbxe0 {
  --lp-button-inline-icon: var(--lp-size-8);
  --lp-button-gap: var(--lp-size-4);
  --lp-button-inline-text: var(--lp-size-12);
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/Button.module.css"],"names":[],"mappings":"AAAA;EAEE,sDAAsD;EACtD,oDAAoD;AACtD;;AAEA;EACE,sDAAsD;AACxD;;AAFA;EAKE,sDAAsD;AACxD;;AAFA;EAKE,oDAAoD;AACtD;;AAFA;EAKE,SAAS;AACX;;AAFA;EAKE,QAAQ;AACV;;AAFA;EAKE,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,gDAAgD;EAChD,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAAA;EAGE,2DAA2D;EAC3D,oBAAoB;EACpB,UAAU;AACZ;;AAAA;EAGE,YAAY;AACd;;AAAA;EAGE,6DAA6D;AAC/D;;AAAA;EAGE,4DAA4D;AAC9D;;AAAA;EAGE,qCAAqC;EACrC,wDAAwD;AAC1D;;AAAA;EAGE,8CAA8C;EAC9C,8CAA8C;EAC9C,sCAAsC;EACtC,yEAAyE;AAC3E;;AAAA;EAGE,qCAAqC;EACrC,wDAAwD;AAC1D;;AAAA;EAGE,8CAA8C;EAC9C,8CAA8C;EAC9C,sCAAsC;EACtC,oCAAoC;EACpC,wDAAwD;EACxD,yEAAyE;AAC3E;;AAAA;EAGE,WAAW;EACX,wDAAwD;EACxD,yDAAyD;EACzD,kBAAkB;AACpB;;AAAA;;EAIE,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EAEE,wBAAwB;EACxB,+DAA+D;EAC/D,mEAAmE;EACnE,2CAA2C;AAC7C;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EAEE,wBAAwB;EACxB,yIAAyI;EACzI,6DAA6D;EAC7D,oDAAoD;EACpD,UAAU;AACZ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,8DAA8D;EAC9D,qDAAqD;AACvD;;AAEA;EACE,+DAA+D;EAC/D,sDAAsD;AACxD;;AAEA;EACE,8DAA8D;EAC9D,sEAAsE;EACtE,qDAAqD;AACvD;;AAEA;EAEE,wBAAwB;EACxB,6IAA6I;EAC7I,iEAAiE;EACjE,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,kEAAkE;EAClE,sEAAsE;AACxE;;AAEA;EAEE,wBAAwB;EACxB,8DAA8D;EAC9D,2CAA2C;AAC7C;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,yDAAyD;EACzD,yDAAyD;EACzD,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EAIE,8CAA8C;EAC9C,8CAA8C;EAC9C,sCAAsC;EACtC,yBAAyB;EACzB,yEAAyE;AAC3E;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,mCAAmC;EACnC,qEAAqE;AACvE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,kEAAkE;AACpE;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,kEAAkE;EAClE,yBAAyB;EACzB,yEAAyE;AAC3E;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,0CAA0C;AAC5C","sourcesContent":[".base {\n  composes: interactive from \"./base.module.css\";\n  --lp-button-inline-start: var(--lp-button-inline-text);\n  --lp-button-inline-end: var(--lp-button-inline-text);\n}\n\n.base:has( > [slot=\"start-icon\"]), .base[data-pending] {\n  --lp-button-inline-start: var(--lp-button-inline-icon);\n}\n\n.base:has( > [slot=\"end-icon\"]) {\n  --lp-button-inline-end: var(--lp-button-inline-icon);\n}\n\n.base > .progress, .base > [slot=\"start-icon\"] {\n  order: -1;\n}\n\n.base > [slot=\"end-icon\"] {\n  order: 1;\n}\n\n.button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: var(--lp-border-radius-medium);\n  align-items: center;\n  gap: var(--lp-button-gap, var(--lp-spacing-200));\n  white-space: nowrap;\n  border: none;\n  outline: none;\n  justify-content: center;\n  margin: 0;\n  text-decoration: none;\n  display: inline-flex;\n  position: relative;\n}\n\n.button[data-focus-visible] {\n  outline: 2px solid var(--lp-color-shadow-interactive-focus);\n  outline-offset: -2px;\n  z-index: 2;\n}\n\n.button[data-disabled] {\n  opacity: .64;\n}\n\n:global([data-spacing=compact][data-orientation=horizontal]) > :is(.primary, .destructive):not(:first-child) {\n  border-inline-start: 1px solid var(--lp-button-divider-color);\n}\n\n:global([data-spacing=compact][data-orientation=vertical]) > :is(.primary, .destructive):not(:first-child) {\n  border-block-start: 1px solid var(--lp-button-divider-color);\n}\n\n.small {\n  font: var(--lp-text-label-2-semibold);\n  padding-block: calc(3px + var(--lp-button-padding, 0px));\n}\n\n.medium, .small {\n  --lp-button-inline-text: var(--lp-spacing-300);\n  --lp-button-inline-icon: var(--lp-spacing-300);\n  --lp-button-gap: var(--lp-spacing-200);\n  padding-inline: var(--lp-button-inline-start) var(--lp-button-inline-end);\n}\n\n.medium {\n  font: var(--lp-text-label-1-semibold);\n  padding-block: calc(5px + var(--lp-button-padding, 0px));\n}\n\n.large {\n  --lp-button-inline-text: var(--lp-spacing-400);\n  --lp-button-inline-icon: var(--lp-spacing-400);\n  --lp-button-gap: var(--lp-spacing-200);\n  font: var(--lp-text-body-1-semibold);\n  padding-block: calc(7px + var(--lp-button-padding, 0px));\n  padding-inline: var(--lp-button-inline-start) var(--lp-button-inline-end);\n}\n\n:global([data-lp-hit-area=expanded]) .button.small:before {\n  content: \"\";\n  inset-block: min(0px,calc((100% - var(--lp-size-32))/2));\n  inset-inline: min(0px,calc((100% - var(--lp-size-32))/2));\n  position: absolute;\n}\n\n:global([data-lp-hit-area=expanded]\n\t\t\t:is([data-spacing=compact],[data-appearance=default])[data-orientation=horizontal]) > .button.small:before {\n  inset-inline: 0;\n}\n\n:global([data-lp-hit-area=expanded]\n\t\t\t:is([data-spacing=compact],[data-appearance=default])[data-orientation=vertical]) > .button.small:before {\n  inset-block: 0;\n}\n\n.default {\n  composes: button;\n  --lp-button-padding: 0px;\n  background-color: var(--lp-color-bg-interactive-secondary-base);\n  border: 1px solid var(--lp-color-border-interactive-secondary-base);\n  color: var(--lp-color-text-ui-primary-base);\n}\n\n.default[data-hovered]:where(:not([aria-disabled=\"true\"])) {\n  background-color: var(--lp-color-bg-interactive-secondary-hover);\n}\n\n.default[data-pressed]:where(:not([aria-disabled=\"true\"])) {\n  background-color: var(--lp-color-bg-interactive-secondary-active);\n}\n\n.default[data-focus-visible] {\n  background-color: var(--lp-color-bg-interactive-secondary-focus);\n}\n\n.primary {\n  composes: button;\n  --lp-button-padding: 1px;\n  --lp-button-divider-color: color-mix(in oklab,var(--lp-color-shadow-interactive-primary) 40%,var(--lp-color-bg-interactive-primary-base));\n  background-color: var(--lp-color-bg-interactive-primary-base);\n  color: var(--lp-color-text-interactive-primary-base);\n  z-index: 1;\n}\n\n.primary [data-icon] {\n  fill: var(--lp-color-text-interactive-primary-base);\n}\n\n.primary[data-hovered]:where(:not([aria-disabled=\"true\"])) {\n  background-color: var(--lp-color-bg-interactive-primary-hover);\n  color: var(--lp-color-text-interactive-primary-hover);\n}\n\n.primary[data-pressed]:where(:not([aria-disabled=\"true\"])) {\n  background-color: var(--lp-color-bg-interactive-primary-active);\n  color: var(--lp-color-text-interactive-primary-active);\n}\n\n.primary[data-focus-visible] {\n  background-color: var(--lp-color-bg-interactive-primary-focus);\n  box-shadow: inset 0 0 0 3px var(--lp-color-shadow-interactive-primary);\n  color: var(--lp-color-text-interactive-primary-focus);\n}\n\n.destructive {\n  composes: button;\n  --lp-button-padding: 1px;\n  --lp-button-divider-color: color-mix(in oklab,var(--lp-color-shadow-interactive-primary) 40%,var(--lp-color-bg-interactive-destructive-base));\n  background-color: var(--lp-color-bg-interactive-destructive-base);\n  color: var(--lp-color-text-interactive-primary-base);\n}\n\n.destructive [data-icon] {\n  fill: var(--lp-color-text-interactive-primary-base);\n}\n\n.destructive[data-hovered]:where(:not([aria-disabled=\"true\"])) {\n  background-color: var(--lp-color-bg-interactive-destructive-hover);\n}\n\n.destructive[data-pressed]:where(:not([aria-disabled=\"true\"])) {\n  background-color: var(--lp-color-bg-interactive-destructive-active);\n}\n\n.destructive[data-focus-visible] {\n  background-color: var(--lp-color-bg-interactive-destructive-focus);\n  box-shadow: inset 0 0 0 3px var(--lp-color-shadow-interactive-primary);\n}\n\n.minimal {\n  composes: button;\n  --lp-button-padding: 1px;\n  background-color: var(--lp-color-bg-interactive-tertiary-base);\n  color: var(--lp-color-text-ui-primary-base);\n}\n\n.minimal[data-hovered]:where(:not([aria-disabled=\"true\"])) {\n  background-color: var(--lp-color-bg-interactive-tertiary-hover);\n}\n\n.minimal[data-pressed]:where(:not([aria-disabled=\"true\"])) {\n  background-color: var(--lp-color-bg-interactive-tertiary-active);\n}\n\n.minimal[data-focus-visible] {\n  background-color: var(--lp-color-bg-interactive-tertiary-focus);\n}\n\n.button[data-selected]:where(button, label) {\n  background-color: var(--lp-color-bg-interactive-selected);\n  border-color: var(--lp-color-border-interactive-selected);\n  z-index: 1;\n}\n\n.button[data-pending] {\n  cursor: wait;\n}\n\n.button[data-pending] [data-icon], .pending {\n  opacity: .5;\n}\n\n.progress {\n  --fill-color: currentColor;\n}\n\n.picker {\n  composes: base from \"./Input.module.css\";\n  composes: _default from \"./Input.module.css\";\n  composes: group from \"./Group.module.css\";\n  --lp-button-inline-text: var(--lp-spacing-300);\n  --lp-button-inline-icon: var(--lp-spacing-300);\n  --lp-button-gap: var(--lp-spacing-300);\n  gap: var(--lp-button-gap);\n  padding-inline: var(--lp-button-inline-start) var(--lp-button-inline-end);\n}\n\n.picker [data-icon]:last-child {\n  fill: var(--lp-color-fill-ui-secondary);\n}\n\n:where(html[data-launchpad-button-spacing]) .small {\n  --lp-button-inline-icon: var(--lp-size-4);\n  --lp-button-gap: var(--lp-size-2);\n  --lp-button-inline-text: var(--lp-size-6);\n  font: var(--lp-text-label-1-medium);\n  padding-block: calc(var(--lp-size-1) + var(--lp-button-padding, 0px));\n}\n\n:where(html[data-launchpad-button-spacing]) .small .stringText {\n  font: inherit;\n}\n\n:where(html[data-launchpad-button-spacing]) .small > svg {\n  height: var(--lp-size-14);\n  width: var(--lp-size-14);\n}\n\n:where(html[data-launchpad-button-spacing]) .medium {\n  --lp-button-inline-icon: var(--lp-size-6);\n  --lp-button-gap: var(--lp-size-3);\n  --lp-button-inline-text: calc(var(--lp-size-6) + var(--lp-size-3));\n}\n\n:where(html[data-launchpad-button-spacing]) .base.picker {\n  --lp-button-inline-icon: var(--lp-size-6);\n  --lp-button-gap: var(--lp-size-3);\n  --lp-button-inline-text: calc(var(--lp-size-6) + var(--lp-size-3));\n  gap: var(--lp-button-gap);\n  padding-inline: var(--lp-button-inline-start) var(--lp-button-inline-end);\n}\n\n:where(html[data-launchpad-button-spacing]) .large {\n  --lp-button-inline-icon: var(--lp-size-8);\n  --lp-button-gap: var(--lp-size-4);\n  --lp-button-inline-text: var(--lp-size-12);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `qAkVquXTPIw5OOjz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["interactive"]}`,
	"progress": `pLbjuipDnIQq4CjT`,
	"button": `R0s2xO5mjiMQTGsJ`,
	"primary": `sNaMUneaUQtLIw9K R0s2xO5mjiMQTGsJ`,
	"destructive": `AfUPnEG_w4EK4Drs R0s2xO5mjiMQTGsJ`,
	"small": `oFLacyeZZ4QtTWGw`,
	"medium": `SdypMiIBMQ0dORgh`,
	"large": `AqwHsmWS4oERbxe0`,
	"default": `AVtbvvllnowOwdkm R0s2xO5mjiMQTGsJ`,
	"minimal": `FbfCfkse98KF6seC R0s2xO5mjiMQTGsJ`,
	"pending": `AAHxZOiXG2E9j8sy`,
	"picker": `W3_PUi1brqEJgtXt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["base"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["_default"]} ${___CSS_LOADER_ICSS_IMPORT_2___.locals["group"]}`,
	"stringText": `iD4tuvolrkYC_GAd`
};
export default ___CSS_LOADER_EXPORT___;
